import React from "react";
import ReactApexChart from "react-apexcharts";


export default class CChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    
    };

  }

  render() {

    const dates = this.props.ir_data.map(x => {
      console.log('Dates', x);
      return x[0];
    });

    const irData = this.props.ir_data.map(x => {
      return x[1];
    });

    const rfData = this.props.rf_data.map(x => {
      return x[1];
    });

    const opt1 = {
          
      seriesRF: [{
        name: 'Rainfall (mm)',
        type: 'column',
        data: rfData
      }, {
        name: 'Irrigation Requirement (TMC)',
        type: 'line',
        data: irData
      }],
      optionsRF: {
        chart: {
          id: 'irrchart4',
          height: 350,
          type: 'line',
          toolbar: {
            autoSelected: 'pan',
            show: false
          }
        },
        forecastDataPoints: {
          count: 25,
          // count: this.props.forecastdays,
        },
        stroke: {
          width: [0, 4]
        },
        dataLabels: {
          enabled: false,
          // enabledOnSeries: [1]
        },
        labels: dates,
        
        xaxis: {
          type: 'datetime',
          labels: {
            format: 'dd MMM yy',
            }, 
          tooltip: {
            enabled: false
          }
        },
        yaxis: [{
          title: {
            text: 'Rainfall (mm)',
          },
        
        }, {
          opposite: true,
          title: {
            text: 'Irrigation Requirement (TMC)'
          }
        }]
      },
    
    
    };

    return (

      <div id="wrapper-rf" style={{height: '100%'}}>
        <div id="chart-bar-rf" style={{height: '80%'}}>
          <ReactApexChart
            key={"rainfall-chart"} 
            options={opt1.optionsRF} 
            series={opt1.seriesRF} 
            type="line" 
            height={'100%'} 
          />
        </div>
      </div>
      
    );
  }
}
